const userApiHost = process.env.NEXT_PUBLIC_USER_API

const constants = {
  address: {
    addressLocality: 'Tanjong Pagar',
    addressRegion: 'Singapore',
    postalCode: '068913',
    streetAddress: '120 Robinson Road, Suite 1215, Singapore 068913'
  },
  webURL: process.env.NEXT_PUBLIC_WEB_URL,
  api: {
    root: 'https://www.abillion.com',
    ambassadors: `${userApiHost}v1/ambassadors/`,
    auth: {
      // Login uses the Next server instead of User API
      login: `/v1/auth/login`,
      logout: `/v1/auth/logout`,
      session: `/v1/auth/session`,
      auth: `${userApiHost}v1/auth/`,
      check: `${userApiHost}v1/auth/check/`,
      signup: `${userApiHost}v1/auth/signup`
    },
    email: {
      ambassadors: `${userApiHost}v1/email/ambassadors`,
      contact: `${userApiHost}v1/email/contact`,
      subscribe: `${userApiHost}v1/email/subscribe`
    },
    reports: `${userApiHost}v1/reports/`,
    reviews: `${userApiHost}v1/reviews/`,
    users: `${userApiHost}v1/users/`,
    v2: {
      impressions: `${userApiHost}v2/impressions`,
      users: `${userApiHost}v2/users`,
      images: {
        upload: `${userApiHost}v2/images/upload`
      }
    }
  },
  links: { onelink: 'http://onelink.to/mk3kg4' },
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ],
  dates: {
    months: {
      full: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      short: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
    }
  },
  defaultImage: {
    official:
      'https://res.cloudinary.com/abillionveg/image/upload/v1612251226/web/NEW-ab-orange-linkpreview-1200x630.jpg',
    vegan: '/static/bg-green.webp',
    vegetarian: '/static/bg-seafoam.webp',
    product: '/static/bg-grey.webp'
  },
  keys: {
    LOGGED_OUT_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2MTMzNTc1OTV9.Nn0jgaQ4ssLzAgMW1f9Z_SN-TDOabRv0p8QaLaHOXX4'
  },
  lists: {
    allergens: [
      'garlic',
      'onion',
      'eggs',
      'milk',
      'nuts',
      'seeds',
      'gluten',
      'soya'
    ],
    priceRange: ['$', '$$', '$$$', '$$$$'],
    ratingsDescription: [
      'please rate',
      'terrible',
      'poor',
      'average',
      'very good',
      'excellent'
    ],
    sortBy: [
      'Popularity',
      // 'Rating - high to low',
      'Veg. Friendliness',
      // 'Cost - high to low',
      // 'Cost - low to high',
      'Distance'
    ],
    dishSortBy: [
      'Popularity',
      'Rating',
      // 'Cost - high to low',
      // 'Cost - low to high',
      'Distance'
    ],

    tabs: ['info', 'photos', 'dishes', 'reviews'],
    vegFriendliness: ['unfriendly', 'friendly', 'very friendly']
  },
  reviews: {
    restaurant: ['overall'],
    dish: ['taste', 'presentation', 'nutrition', 'value', 'originality'],
    product: ['overall'],
    reportOptions: ['wrong information', 'inappropriate content']
  },
  productRatings: {
    food: ['taste', 'presentation', 'nutrition', 'value', 'originality'],
    'health and beauty': ['overall'],
    apparel: ['overall']
  },
  abillionUserId: '59db18f27687550004329eb3',
  activity: [
    'commentArticleSuccess',
    'commentArticleTag',
    'commentReviewSuccess',
    'commentReviewTag',
    'followCollectionSuccess',
    'followSuccess',
    'likeArticleSuccess',
    'likeCollectionSuccess',
    'likeReviewCommentSuccess',
    'likeReviewSuccess',
    'newReviewTag',
    'redeemAnimalSuccessGrouped',
    'redeemAnimalSuccess',
    'redeemFailure',
    'replyArticleSuccess',
    'replyReviewSuccess',
    'repostReviewSuccess'
  ]
}

export default constants
